import { NavigationMixin } from "../../support/mixins";
import Vue from "vue";
export default Vue.extend({
    name: "Loading",
    mixins: [NavigationMixin],
    props: {
        message: {
            required: false,
            default: 'Loading'
        },
        show_long_loading: {
            type: Boolean,
            required: false,
            default: true
        },
        timeout: {
            type: Number,
            required: false,
            default: 10000
        }
    },
    data: function () {
        return {
            long_loading: false
        };
    },
    mounted: function () {
        var vm = this;
        setTimeout(function () {
            vm.long_loading = true;
        }, this.timeout);
    }
});
